// 折扣码输入框

class CartDiscount extends HTMLElement {
    #activeFetch = null;
    #createAbortController() {
        if (this.#activeFetch) {
            this.#activeFetch.abort();
        }
        const abortController = new AbortController();
        this.#activeFetch = abortController;
        return abortController;
    }

    constructor() {
        super();
        this.symbol = this.dataset.symbol || '$';
        this.input = this.querySelector('input[type="text"]');
        this.button = this.querySelector('button[type="submit"]');
        this.codeList = window.staticData.codeList;
        
        this.input.addEventListener('keyup', this.onInputChange.bind(this));
        this.input.addEventListener('input', this.onInputChange.bind(this));
        this.button.addEventListener('click', this.onButtonClick.bind(this));

        this.codeTemp = this.querySelector('.discount-code-list');

        this.addEventListener("click", (event) => {

            if (event.target.localName == 'div' && event.target.className == "discount-del") {
                const code = event.target.dataset.code || '';
                if (code) {
                    event.target.closest(".code-item").classList.add("is-loading");
                    this.deleteChange(code, event);
                }
            } else if (event.target.localName == 'div' && event.target.classList.contains("cart-bottom") && event.target.classList.length == 1) {
                const code = event.target.dataset.code || '';
                this.onRadiosChange(code);
            }

        });
    }
    connectedCallback() {

        var list = document.querySelectorAll("cart-items .cart__item");
        // 循环 list，找到每个 item 中存在 judge__discount 节点的信息
        var automaticCode = [];
        var emptyCode = [];
        list.forEach(item => {
            const discountNode = item.querySelector('.judge__discount');
            if (discountNode) {
                automaticCode.push(discountNode.dataset.amount);
            } else {
                emptyCode.push(0);
            }
        });

        if (list.length == automaticCode.length) {
            this.checkDiscount();
            // 当所有的商品选项存在自动折扣 不展示折扣信息
            this.querySelector(".cart-discount-list").style.display = "none";
        } else {
            this.querySelector(".cart-discount-list").style.display = "block";


            if (list.length == emptyCode.length) {
                // 
                this.refreshCartDiscounts();
            } else {
                
                this.refreshCartDiscounts(automaticCode);
            }

            // 每隔 1.5 秒刷新一次
            // setInterval(this.refreshCartDiscounts(), 1500);

        }

    }

    async refreshCartSwiper(automaticCode) {
        const applyList = document.querySelectorAll(".discount-apply");
        var applicable = [];
        var totalPrice = 0;

        const abortController = this.#createAbortController();

        this.querySelector(".cart-discount-list").classList.add("is-loading");
        this.querySelector("#mySwiper .swiper-wrapper").innerHTML = "";

        const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                discount: automaticCode && automaticCode.type == 'remove' ? '' : automaticCode.code,
                sections: [this.dataset.sectionId],
                t: new Date().getTime()
            }),
            signal: abortController.signal,
        });
        try {

            const cart = await response.json();
            const codes = cart.discount_codes;
            totalPrice = (cart.original_total_price / 100).toFixed(0);

            // 判断 cart.discount_codes 中 applicable=false 的数量是否和 this.codeList 的数量相等
            const notApplicableCount = codes.filter(discount => discount.applicable === false).length;
            if (notApplicableCount === this.codeList.length) {
                this.querySelector(".cart-discount-list").style.display = "none";

            }else{
                if (codes.length > 0) {
                    const codeValue = [];
                    codes.forEach(discount => {
                        const discountCodeList = this.querySelector('.discount-code-list');
                        if (discount.applicable) {
                            codeValue.push(discount.code);
                            applicable.push(discount.code);
                            if (discountCodeList && ![...discountCodeList.children].some(item => item.querySelector("span").textContent.trim() === discount.code)) {
                                const codeItem = document.createElement('div');
                                codeItem.className = 'code-item';
                                codeItem.innerHTML = `<span>${discount.code}</span><div class="discount-del" data-code="${discount.code}"></div>`;
                                discountCodeList.appendChild(codeItem);
                            }
                        } else {
                            const codeItem = this.querySelector(`.discount-del[data-code="${discount.code}"]`);
                            if (codeItem) {
                                codeItem.parentNode.remove();
                            }
                        }
                    });

                    const showType = codes.find(discount => discount.applicable == true);
    
                    if (showType) {
                        const valueData = this.codeList.find(discount => discount.code === showType.code);
                        applyList.forEach(item => { 
                            item.style.display = "block"; 
                            item.querySelector("span").textContent = codeValue.join(","); 
                        });
                        if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                            document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "block";
                            document.querySelector(".new-cart-layout .discount-number .new-code").textContent =`-${window.theme.formatMoney(valueData.save * 100).replace(/\.00$/, "")}.00`;
                        }
                    } else {
                        applyList.forEach(item => { 
                            item.style.display = "none";
                        });
                        if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                        document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "none"; 
                        }
                    }
                     // 更新总价文案
                    var totalList = document.querySelectorAll(".cart__total .cart__total__price");
                    totalList.forEach(item => {
                        item.innerHTML = window.theme.formatMoney(cart.items_subtotal_price, theme.moneyWithCurrencyFormat)
                    });


                } else {
                    applyList.forEach(item => { 
                        item.style.display = "none"; 
                        
                    });
                    if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                        document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "none"; 
                    }
                }

                // 先分组：item-checked, item-select, item-no-select
                const checked = [];
                const selectable = [];
                const noSelectable = [];

                this.codeList.forEach(item => {
                    const recommend = applicable.find(discount => discount === item.code);
                    let colorStype = "";
                    if (recommend) {
                        colorStype = "item-checked";
                        checked.push({ item, colorStype, recommend });
                    } else if (Number(totalPrice) > Number(item.name)) {
                        colorStype = "item-select";
                        selectable.push({ item, colorStype, recommend });
                    } else {
                        colorStype = "item-no-select";
                        noSelectable.push({ item, colorStype, recommend });
                    }
                });

                const all = [...checked, ...selectable, ...noSelectable];

                all.forEach(({ item, colorStype, recommend }) => {
                    var warp = document.createElement("div");
                    warp.classList.add("swiper-slide");
                    var temp = `<div class="cart-discount-item ${colorStype}">
                                <div class="cart-contain">
                                    <div>
                                    <div class="cart-code red">${recommend ? '<em></em>' : ''}<span>${window.theme.formatMoney(item.save * 100).replace(/\.00$/, "")}</span>Off</div>
                                    <p class="red">${item.term}</p>
                                    </div>
                                    <div>
                                    <div class="cart-name red">code: ${item.code}</div>
                                    <div class="${recommend ? 'cart-selected' : ''} cart-bottom" data-code ="${item.code}">${recommend ? 'Applied' : 'Apply'}</div>
                                    </div>
                                </div>
                            </div>`;
                    warp.innerHTML = temp;
                    document.querySelector("#mySwiper .swiper-wrapper").appendChild(warp);
                });
                if (window.cartSwiper) {
                    window.cartSwiper.update();
                }
            }

        } catch (error) {
            console.log("刷新折扣失败:", error);

        }

        this.querySelector(".cart-discount-list").classList.remove("is-loading");

    }

    async refreshCartDiscounts(automaticCode) {
        const applyList = document.querySelectorAll(".discount-apply");
        var applicable = [];
        var totalPrice = 0;
        const existingDiscounts = this.codeList.map(item => item.code);;
        const abortController = this.#createAbortController();
        this.querySelector(".cart-discount-list").classList.add("is-loading");
        this.querySelector("#mySwiper .swiper-wrapper").innerHTML = ""; 

        const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                discount: automaticCode && automaticCode.type == 'remove' ? (automaticCode && automaticCode.code ? automaticCode.code : '') : existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });
        const cart = await response.json();
        const codes = cart.discount_codes;
        totalPrice = (cart.original_total_price / 100).toFixed(0);
   
        

        // 判断 cart.discount_codes 中 applicable=false 的数量是否和 this.codeList 的数量相等
        const notApplicableCount = codes.filter(discount => discount.applicable === false).length;
        if (notApplicableCount === this.codeList.length) {
            this.querySelector(".cart-discount-list").style.display = "none";
           
        }else{

            if (codes.length > 0) {
                const codeValue = [];
                codes.forEach(discount => {
                    const discountCodeList = this.querySelector('.discount-code-list');
                    if (discount.applicable) {
                        codeValue.push(discount.code);
                        applicable.push(discount.code);
                        if (discountCodeList && ![...discountCodeList.children].some(item => item.querySelector("span").textContent.trim() === discount.code)) {
                            const codeItem = document.createElement('div');
                            codeItem.className = 'code-item';
                            codeItem.innerHTML = `<span>${discount.code}</span><div class="discount-del" data-code="${discount.code}"></div>`;
                            discountCodeList.appendChild(codeItem);
                        }
                    } else {
                        const codeItem = this.querySelector(`.discount-del[data-code="${discount.code}"]`);
                        if (codeItem) {
                            codeItem.parentNode.remove();
                        }
                    }
                });

                const showType = codes.find(discount => discount.applicable == true);

    
                if (showType) {
                    const valueData = this.codeList.find(discount => discount.code === showType.code);
                    applyList.forEach(item => { 
                        item.style.display = "block"; 
                        
                        item.querySelector("span").textContent = codeValue.join(",");
                    });
                    if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                        document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "block";
                        document.querySelector(".new-cart-layout .discount-number .new-code").innerHTML =`-${window.theme.formatMoney(valueData.save * 100).replace(/\.00$/, "")}.00`;
                    }

                } else {
                    applyList.forEach(item => { 
                    
                        item.style.display = "none";
                    });
                    if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                        document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "none"; 
                        }
                }
                 // 更新总价文案
                var totalList = document.querySelectorAll(".cart__total .cart__total__price");
                totalList.forEach(item => {
                    item.innerHTML = window.theme.formatMoney(cart.items_subtotal_price, theme.moneyWithCurrencyFormat)
                });

            } else {
                applyList.forEach(item => { 
                    item.style.display = "none"; 
                });
                if(document.querySelector(".new-cart-layout .discount-number .new-code")){
                    document.querySelector(".new-cart-layout .discount-number .new-code").style.display = "none"; 
                }
            }

            // 先分组：item-checked, item-select, item-no-select
            const checked = [];
            const selectable = [];
            const noSelectable = [];

            this.codeList.forEach(item => {
                const recommend = applicable.find(discount => discount === item.code);
                let colorStype = "";
                if (recommend) {
                    colorStype = "item-checked";
                    checked.push({ item, colorStype, recommend });
                } else if (Number(totalPrice) > Number(item.name)) {
                    colorStype = "item-select";
                    selectable.push({ item, colorStype, recommend });
                } else {
                    colorStype = "item-no-select";
                    noSelectable.push({ item, colorStype, recommend });
                }
            });

            const all = [...checked, ...selectable, ...noSelectable];

            all.forEach(({ item, colorStype, recommend }) => {
                var warp = document.createElement("div");
                warp.classList.add("swiper-slide");
                var temp = `<div class="cart-discount-item ${colorStype}">
                                <div class="cart-contain">
                                    <div>
                                    <div class="cart-code red">${recommend ? '<em></em>' : ''}<span>${window.theme.formatMoney(item.save * 100).replace(/\.00$/, "")}</span>Off</div>
                                    <p class="red">${item.term}</p>
                                    </div>
                                    <div>
                                    <div class="cart-name red">code: ${item.code}</div>
                                    <div class="${recommend ? 'cart-selected' : ''} cart-bottom" data-code ="${item.code}">${recommend ? 'Applied' : 'Apply'}</div>
                                    </div>
                                </div>
                            </div>`;
                warp.innerHTML = temp;
                document.querySelector("#mySwiper .swiper-wrapper").appendChild(warp);
            });
            this.querySelector(".cart-discount-list").classList.remove("is-loading");

            if (window.cartSwiper) {
                window.cartSwiper.update();
            }
             document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

        }

    }

    // 监测code是否能正常使用
    async checkDiscount() {
        // 获取存在的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        // 获取固定的折扣
        // const fixedValue = this.codeList.map(item => item.code);;

        const abortController = this.#createAbortController();

        var existingDiscounts = [];

        codeValue.forEach((code) => {
            existingDiscounts.push(code.querySelector("span").textContent.trim());
        });


        // 合并 existingDiscounts 和 fixedValue 并去重
        // existingDiscounts = Array.from(new Set([...existingDiscounts, ...fixedValue]));   

        if (existingDiscounts.length == 0) {
            // 执行刷新
            // this.updateSwiper();

            return;
        };


        const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                discount: existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();
        codeValue.forEach((item) => {
            const code = item.querySelector("span").textContent.trim();
            const discount_code = data.discount_codes.find(discount => discount.code === code);
            if (discount_code && !discount_code.applicable) {
                item.remove();
            }
        });

    }
    showToast(message) {
        // 创建新的toast元素
        const toast = document.createElement('div')
        toast.classList.add('sale-public-toast')
        // 设置toast的内容
        toast.innerText = message

        // 将toast添加到页面中
        document.body.appendChild(toast)

        // 在一段时间后移除toast
        setTimeout(function () {
            document.body.removeChild(toast)
        }, 3000)
    }
    onRadiosChange(event) {
        this.input.value = event || '';
        this.onInputChange();
        this.button.click();

    }
    onInputChange() {
        if (this.input.value.trim() !== '') {
            this.button.classList.add('selected');
        } else {
            this.button.classList.classList.remove('selected');
        }
        // 更新按钮状态
        if (this.button.classList.contains('cancle')) {
            this.button.classList.remove('cancle');
            this.button.textContent = 'Apply';
            this.querySelector(".code-info").textContent = '';
        }
    }

    // 删除code
    async deleteChange(code, event) {
        // 获取存在的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        const abortController = this.#createAbortController();

        var existingDiscounts = [];

        codeValue.forEach((code) => {
            existingDiscounts.push(code.querySelector("span").textContent.trim());
        });
        const index = existingDiscounts.indexOf(code);
        existingDiscounts.splice(index, 1);

        const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                // discount: [this.button.classList.contains('cancle') ? '' : discountCodeValue].join(','),
                discount: existingDiscounts.join(','),
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();

        if (data) {
            this.showToast("This is the best discount right now.");
            this.input.value = '';
            this.button.classList.remove('selected');
        }
        // 更新购物车
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            bubbles: true,
            detail: { type: 'remove' }
        }));

        // 删除当前节点
        event.target.parentNode.remove();
        document.querySelector(".new-code").innerHTML = "";
        document.querySelector(".new-code").style.display = "none";

        this.refreshCartDiscounts({ type: 'remove' });

    }

    // 点击按钮
    async onButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.button.disabled = true;
        this.button.classList.add('loading');
        event.preventDefault();

        const discountCodeValue = this.input.value;
        if (!discountCodeValue) {
            this.showToast('Please enter a discount code.');
            this.button.disabled = false;
            this.button.classList.remove('loading');
            this.button.classList.remove('selected');
            this.input.value = '';
            return;
        }

        if (discountCodeValue.toLowerCase().includes('giftcard')) {
            this.showToast('Please apply gift card at checkout.');
            this.button.disabled = false;
            this.button.classList.remove('loading');
            this.button.classList.remove('selected');
            this.input.value = '';
            return;
        }
        // 只能应用一个折扣码
        // 删除之前的code
        var codeValue = this.querySelectorAll(".discount-code-list .code-item");
        codeValue.forEach((item) => { item.remove(); });


        // 获取存在的code
        // var codeValue = this.querySelectorAll(".discount-code-list .code-item");

        const abortController = this.#createAbortController();

        // var existingDiscounts = [];

        // codeValue.forEach((code) => {
        //     existingDiscounts.push(code.querySelector("span").textContent.trim());
        // });

        // existingDiscounts.push(discountCodeValue);



        const response = await fetch(theme.routes.cart_update_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                // discount: [this.button.classList.contains('cancle') ? '' : discountCodeValue].join(','),
                // discount: existingDiscounts.join(','),
                discount: discountCodeValue,
                sections: [this.dataset.sectionId],
            }),
            signal: abortController.signal,
        });

        const data = await response.json();

        if (data) {
            this.button.disabled = false;
            this.button.classList.remove('loading');
        }

        if (data.discount_codes && data.discount_codes.length === 0) {
            this.showToast('You have cancelled the discount code');
            this.input.value = '';
            this.button.classList.remove('selected');

        } else {

            const discount_codes = data.discount_codes.find((discount) => { return discount.code == discountCodeValue; });
            if (discount_codes && discount_codes.applicable) {
                this.showToast(`Success! You saved ${window.theme.formatMoney(data.total_discount)}.`);
                this.input.value = '';
                const discountCodeList = this.querySelector('.discount-code-list');
                if (discountCodeList && ![...discountCodeList.children].some(item => item.querySelector("span").textContent.trim() === discountCodeValue)) {
                    const codeItem = document.createElement('div');
                    codeItem.className = 'code-item';
                    codeItem.innerHTML = `<span>${discountCodeValue}</span><div class="discount-del" data-code="${discountCodeValue}"></div>`;
                    discountCodeList.appendChild(codeItem);
                }
            } else {
                if (data.discount_codes.length > 1) {
                    this.showToast("Discount codes cannot be combined.");
                } else {
                    this.showToast("Invalid code. Please try again.");
                }
            }
            this.input.value = '';
            this.button.classList.remove('selected');
            // 删除不能用的code
            data.discount_codes.forEach((discount) => {
                if (!discount.applicable) {
                    const codeItem = this.querySelector(`.discount-del[data-code="${discount.code}"]`);
                    if (codeItem) {
                        codeItem.parentNode.remove();
                    }
                }
            });

        }
        // 更新购物车
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true, detail: { code: discountCodeValue } }));

        // 更新节点
        this.refreshCartSwiper({code: discountCodeValue});


    }
}
if (!customElements.get('cart-discount-component')) {
    customElements.define('cart-discount-component', CartDiscount);
}

